export const handleRedirection = (path: string) : void => {
    window.open(path, "_blank", "noopener, noreferrer");
};

export const isAuthenticated = () : boolean => {
    return sessionStorage.getItem("authenticationToken") !== null;
}

export const authenticationToken = () : string | null => {
    return sessionStorage.getItem("authenticationToken");
}

export const refreshToken = () : string | null => {
    return sessionStorage.getItem("refreshToken");
}

export const mail = () : string | null => {
    return sessionStorage.getItem("mail");
}

export const role = () : string | null => {
    return sessionStorage.getItem("role");
}

export const isEditor = () : boolean =>  {
    return isAuthenticated() && role() === "Administrator" || role() === "Moderator";
}